import { Market } from 'src/state/master-data/state-models/market';
import { MaterialPriceType } from './material-price-type';

export interface MaterialPrice {
    id: number;
    price: number;
    materialId: number;
    validFrom: Date;
    validTo: Date;
    materialPriceType: MaterialPriceType;
    createdOn: Date;
    createdBy: string;
    updatedOn: Date;
    updatedBy: string;
    modifiedOn: Date;
    modifiedBy: string;
    modifierComments: string;

    marketId: number;
    market: Market
    slaType: string;
    // currentManualPrice: number;
    // currentStandardPrice: number;
    // currentStrategicPrice: number;
}
